"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
var React = require("react");
var pagination_1 = require("wix-ui-core/pagination");
var DoubleChevronLeft_1 = require("../../assets/icons/DoubleChevronLeft");
var DoubleChevronRight_1 = require("../../assets/icons/DoubleChevronRight");
var ChevronLeft_1 = require("../../assets/icons/ChevronLeft");
var ChevronRight_1 = require("../../assets/icons/ChevronRight");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var Pagination_st_css_1 = require("./Pagination.st.css");
/** Pagination component */
exports.Pagination = function (props) {
    return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
        var mobile = _a.mobile, rtl = _a.rtl;
        return (React.createElement(pagination_1.Pagination, __assign({ previousLabel: ChevronLeft_1.ChevronLeft, nextLabel: ChevronRight_1.ChevronRight, firstLabel: DoubleChevronLeft_1.DoubleChevronLeft, lastLabel: DoubleChevronRight_1.DoubleChevronRight, rtl: rtl, showFirstLastNavButtons: props.totalPages > props.maxPagesToShow, paginationMode: mobile ? 'compact' : 'pages', slashLabel: '/' }, props, { className: Pagination_st_css_1.st(Pagination_st_css_1.classes.root, { mobile: mobile, rtl: rtl }, props.className) })));
    }));
};
exports.Pagination.displayName = 'Pagination';
exports.Pagination.defaultProps = {
    maxPagesToShow: 5,
};
//# sourceMappingURL=Pagination.js.map